import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import ScopeDisplay from './ScopeDisplay'

const useStyles = makeStyles((theme) => ({
  scopePicker: {
    flex: '1 0 auto',
    minWidth: '300px',
    marginRight: '10px',
    // Hides the default caret injected by Select — we render our own in ScopeDisplayItem
    '& [class*="makeStyles-caret-"]': {
      display: 'none'
    }
  }
}))

const ScopePicker = ({
  headingLabel,
  avatarSize,
  avatarFontSize,
  titleFontSize,
  labelFontSize,
  labelPosition
}) => {
  const classes = useStyles()

  return (
    <div className={classes.scopePicker}>
      <ScopeDisplay
        headingLabel={headingLabel}
        avatarSize={avatarSize}
        avatarFontSize={avatarFontSize}
        titleFontSize={titleFontSize}
        labelFontSize={labelFontSize}
        labelPosition={labelPosition}
      />
    </div>
  )
}

ScopePicker.propTypes = {
  headingLabel: PropTypes.string,
  avatarSize: PropTypes.string,
  avatarFontSize: PropTypes.string,
  titleFontSize: PropTypes.string,
  labelFontSize: PropTypes.string,
  labelPosition: PropTypes.oneOf(['top', 'bottom'])
}

export default ScopePicker
